export default __webpack_public_path__ + "static/media/propsicon0.9417026f.svg";